import React from 'react';
import {Grid,Grow,Typography} from '@material-ui/core';


import NewsCard from '../NewsCard/NewsCard';
import useStyles from './styles.js';

const infoCards=[
    {color:'#00838f', title:'Latest-news', text:'Give me the latest news'},
    {color:'#4527a0', title:'News by Terms', info:"Donald Trump,Playstation 5,Smartphones..", text:"What's up with playstation 5"},
    {color:'#283593', title:'News by Sources', info:"Wired,BBC News, The Times of India,ABC News..",text:'Give me the news from The Times of India'},
    {color:'#1565c0', title:'News by Categories', info:"Tech,Sports..", text:'Give me the latest Technology news'}
];


const NewsCards=({articles,activeArticle})=>{

    const classes=useStyles();

    if(!articles.length){
        return(
            <Grow in>
            <Grid className={classes.container} container alignItems="stretch" spacing={3}>
            {
                infoCards.map((infoCard)=>(
                    <Grid item xs={12} sm={6} md={4} lg={3} className={classes.infoCard}>
                    <div className={classes.card} style={{backgroundColor:infoCard.color}}>
                        <Typography variant="h5">{infoCard.title}</Typography>
                        {infoCard.info ? (<Typography variant="h6"><strong>{infoCard.title.split(' ')[2]}:</strong>{infoCard.info}</Typography>):null}
                        <Typography variant="h6">Try Saying : <br/><i> {infoCard.text}</i></Typography>
                    </div>
                    </Grid>
                ))
            }
            </Grid>
            </Grow>
        );
    }

    return (
        <Grow in>
            <Grid className={classes.container} container alignitems="stretch" spacing={3}>
            {articles.map((article,i)=>(
                <Grid item xs={12} sm={6} md={4} lg={3} style={{display:'flex'}}>
                    <NewsCard article={article} activeArticle={activeArticle} i={i}/>
                </Grid>
            ))}
            </Grid>
        </Grow>
    );

}

export default NewsCards;